import { Link } from 'react-router-dom';
import { Building2, Store, Smartphone, Clock, Shield, CheckCircle, CircleAlert  } from 'lucide-react';
import { HeaderLanding } from "../components/ui/header-landings";
import { Footer } from '../components/ui/footer';

const paymentMethods = [
  {
    icon: Building2,
    title: "Transferencia Bancaria",
    description: "Realiza una transferencia desde tu banco a nuestra cuenta. Es el método más rápido para confirmar tu pago.",
    details: [
      "Banco: Banamex",
      "Titular: Aldo Bernal Sandoval",
      "CLABE: 0021 8090 5439 7748 81"
    ],
    note: "Recuerda incluir tu nombre completo en el concepto de la transferencia.",
    color: "#0022FF"
  },
  {
    icon: Store,
    title: "Depósito en OXXO",
    description: "Deposita en cualquier tienda OXXO de la República Mexicana. Disponible las 24 horas, los 7 días de la semana.",
    details: [
      "Banco: Santander México",
      "No de tarjeta: 5579 1004 4529 0057",
      "Banco: Scotiabank",
      "No de tarjeta: 4421 7700 1004 0435"
    ],
    note: "El depósito puede tardar de 1 a 24 horas en reflejarse.",
    color: "#FF3333"
  },
  {
    icon: Smartphone,
    title: "SPEI (Transferencia Interbancaria)",
    description: "Transfiere desde cualquier banco a través del sistema SPEI. Las transferencias se reflejan en minutos.",
    details: [
      "Disponible desde cualquier banco",
      "Transferencias instantáneas",
      "Sin comisiones adicionales",
      "Usa la CLABE proporcionada"
    ],
    note: "Recuerda incluir tu nombre completo en el concepto de la transferencia.",
    color: "#10B981"
  }
];

const steps = [
  {
    number: "01",
    title: "Selecciona tus boletos",
    description: "Elige el sorteo y los números que quieres apartar."
  },
  {
    number: "02",
    title: "Completa tus datos",
    description: "Ingresa tu nombre, teléfono y correo electrónico."
  },
  {
    number: "03",
    title: "Realiza el pago",
    description: "Transfiere el monto total usando cualquiera de nuestros métodos de pago."
  },
  {
    number: "04",
    title: "Envía tu comprobante",
    description: "Manda la foto de tu comprobante por WhatsApp o por correo electrónico para confirmar tu compra."
  }
];

export default function PaymentMethodsPage() {

  return (
    <div className="min-h-screen bg-white">
       {/* Header */}
      <HeaderLanding />

      <main>
        {/* Hero Section */}
        <section className="border-b-2 border-black py-16 bg-[#F3F4F6]">
          <div className="px-4 sm:px-8 max-w-7xl mx-auto text-center">
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#FF3333] mb-2">
              Paga fácil y seguro
            </p>
            <h1 className="text-4xl sm:text-5xl font-black tracking-tighter mb-4">
              MÉTODOS DE PAGO
            </h1>
            <p className="text-[#4B5563] max-w-md mx-auto">
              Aceptamos diferentes formas de pago para tu comodidad. Elige la que mejor te convenga.
            </p>
          </div>
        </section>

        {/* Payment Methods Section */}
        <section className="py-16 border-b-2 border-black">
          <div className="px-4 sm:px-8 max-w-7xl mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {paymentMethods.map((method, index) => {
                const IconComponent = method.icon;
                return (
                  <div 
                    key={index}
                    className="bg-white border-2 border-black shadow-[8px_8px_0_0_#000000] hover:-translate-y-1 hover:shadow-[12px_12px_0_0_#000000] transition-all"
                  >
                    <div 
                      className="p-6 border-b-2 border-black"
                      style={{ backgroundColor: method.color }}
                    >
                      <IconComponent className="w-12 h-12 text-white mb-4" />
                      <h3 className="text-2xl font-bold text-white">{method.title}</h3>
                    </div>
                    <div className="p-6 space-y-4">
                      <p className="text-[#4B5563]">{method.description}</p>
                      
                      <ul className="space-y-2">
                        {method.details.map((detail, i) => (
                          <li key={i} className="flex items-start gap-2 text-sm">
                            <CheckCircle className="w-4 h-4 text-[#10B981] flex-shrink-0 mt-0.5" />
                            <span>{detail}</span>
                          </li>
                        ))}
                      </ul>

                      <div className="bg-[#F3F4F6] border-l-4 border-[#F59E0B] p-3">
                        <p className="text-xs text-[#4B5563]">
                          <strong>Nota:</strong> {method.note}
                        </p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
           <div className="mt-8 flex items-center justify-center gap-4">
              <CircleAlert  className="w-5 h-5 text-[#4B5563]" />
              <p className="text-[#4B5563] text-sm">
               Si una cuenta presenta alta demanda, por favor intenta con cualquiera de las otras opciones disponibles
              </p>
            </div>
        </section>

        {/* Process Steps Section */}
        <section className="py-16 bg-[#0A0A0A] text-white">
          <div className="px-4 sm:px-8 max-w-7xl mx-auto">
            <div className="text-center mb-12">
              <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#FF3333] mb-2">
                Proceso de compra
              </p>
              <h2 className="text-3xl sm:text-4xl font-bold tracking-tight">
                ¿CÓMO COMPRAR TUS BOLETOS?
              </h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
              {steps.map((step, index) => (
                <div key={index} className="relative">
                  <div className="text-6xl font-black text-[#FF3333] opacity-50 mb-4">
                    {step.number}
                  </div>
                  <h3 className="text-xl font-bold mb-2">{step.title}</h3>
                  <p className="text-gray-400">{step.description}</p>
                  
                  {index < steps.length - 1 && (
                    <div className="hidden md:block absolute top-8 left-full w-full h-0.5 bg-[#FF3333] opacity-30" style={{ width: '50%' }}></div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Security Section */}
        <section className="py-16">
          <div className="px-4 sm:px-8 max-w-4xl mx-auto">
            <div className="bg-[#F3F4F6] border-2 border-black p-8 shadow-[8px_8px_0_0_#000000]">
              <div className="flex items-start gap-6">
                <div className="w-16 h-16 bg-[#10B981] flex items-center justify-center flex-shrink-0">
                  <Shield className="w-8 h-8 text-white" />
                </div>
                <div>
                  <h3 className="text-2xl font-bold mb-4">Compra Segura</h3>
                  <p className="text-[#4B5563] mb-4">
                    Tu seguridad es nuestra prioridad. Todos los pagos son verificados manualmente por nuestro equipo 
                    antes de confirmar tu participación en el sorteo.
                  </p>
                  <ul className="space-y-2">
                    <li className="flex items-center gap-2 text-sm">
                      <CheckCircle className="w-4 h-4 text-[#10B981]" />
                      <span>Verificación manual de cada pago</span>
                    </li>
                    <li className="flex items-center gap-2 text-sm">
                      <CheckCircle className="w-4 h-4 text-[#10B981]" />
                      <span>Confirmación por WhatsApp</span>
                    </li>
                    <li className="flex items-center gap-2 text-sm">
                      <CheckCircle className="w-4 h-4 text-[#10B981]" />
                      <span>Boletos digitales con número único</span>
                    </li>
                    <li className="flex items-center gap-2 text-sm">
                      <CheckCircle className="w-4 h-4 text-[#10B981]" />
                      <span>Consulta el estado de tu compra en cualquier momento</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="mt-8 flex items-center justify-center gap-4">
              <Clock className="w-5 h-5 text-[#4B5563]" />
              <p className="text-[#4B5563] text-sm">
                Tiempo de confirmación: <strong>1-24 horas</strong> después de recibir tu comprobante
              </p>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-16 border-t-2 border-black bg-[#F3F4F6]">
          <div className="px-4 sm:px-8 max-w-4xl mx-auto text-center">
            <h2 className="text-3xl font-bold mb-4">¿Listo para participar?</h2>
            <p className="text-[#4B5563] mb-8">
              Elige tu sorteo favorito y aparta tus boletos de la suerte.
            </p>
            <Link 
              to="/"
              className="inline-flex items-center gap-2 bg-[#FF3333] text-white font-bold uppercase tracking-wider border-2 border-black px-8 py-4 shadow-[4px_4px_0_0_#000000] hover:translate-y-[2px] hover:translate-x-[2px] hover:shadow-[2px_2px_0_0_#000000] transition-all"
            >
              Ver Sorteos Disponibles
            </Link>
          </div>
        </section>
      </main>

       {/* Footer */}
          <Footer />
    </div>
  );
}
